import { createContext, useContext, useState } from "react";

// Create Context
const SupportContext = createContext();

// Context Provider Component
export const SupportProvider = ({ children }) => {
  const [combinationDetails, setCombinationDetails] = useState([]);
  const [card1CombinationDetails, setCard1CombinationDetails] = useState([]);
  const [card2CombinationDetails, setCard2CombinationDetails] = useState([]);
  const [popupCombinationDetails, setPopupCombinationDetails] = useState([]);
  const [bmfCard1CombinationDetails, setbmfCard1CombinationDetails] = useState(
    [],
  );
  const [bmfCard2CombinationDetails, setbmfCard2CombinationDetails] = useState(
    [],
  );
  const [bmfPopupCombinationDetails, setbmfPopupCombinationDetails] = useState(
    [],
  );
  const [fgCard1CombinationDetails, setfgCard1CombinationDetails] = useState(
    [],
  );
  const [fgCard2CombinationDetails, setfgCard2CombinationDetails] = useState(
    [],
  );
  const [fgPopupCombinationDetails, setfgPopupCombinationDetails] = useState(
    [],
  );
  const [bpCard1CombinationDetails, setbpCard1CombinationDetails] = useState(
    [],
  );
  const [bpCard2CombinationDetails, setbpCard2CombinationDetails] = useState(
    [],
  );
  const [bpPopupCombinationDetails, setbpPopupCombinationDetails] = useState(
    [],
  );
  const [ciCard1CombinationDetails, setciCard1CombinationDetails] = useState(
    [],
  );
  const [ciCard2CombinationDetails, setciCard2CombinationDetails] = useState(
    [],
  );
  const [ciPopupCombinationDetails, setciPopupCombinationDetails] = useState(
    [],
  );
  const [prCard1CombinationDetails, setprCard1CombinationDetails] = useState(
    [],
  );
  const [prCard2CombinationDetails, setprCard2CombinationDetails] = useState(
    [],
  );
  const [prPopupCombinationDetails, setprPopupCombinationDetails] = useState(
    [],
  );

  return (
    <SupportContext.Provider
      value={{
        combinationDetails,
        setCombinationDetails,
        card1CombinationDetails,
        setCard1CombinationDetails,
        card2CombinationDetails,
        setCard2CombinationDetails,
        popupCombinationDetails,
        setPopupCombinationDetails,
        bmfCard1CombinationDetails,
        setbmfCard1CombinationDetails,
        bmfCard2CombinationDetails,
        setbmfCard2CombinationDetails,
        bmfPopupCombinationDetails,
        setbmfPopupCombinationDetails,
        fgCard1CombinationDetails,
        setfgCard1CombinationDetails,
        fgCard2CombinationDetails,
        setfgCard2CombinationDetails,
        fgPopupCombinationDetails,
        setfgPopupCombinationDetails,
        bpCard1CombinationDetails,
        setbpCard1CombinationDetails,
        bpCard2CombinationDetails,
        setbpCard2CombinationDetails,
        bpPopupCombinationDetails,
        setbpPopupCombinationDetails,
        ciCard1CombinationDetails,
        setciCard1CombinationDetails,
        ciCard2CombinationDetails,
        setciCard2CombinationDetails,
        ciPopupCombinationDetails,
        setciPopupCombinationDetails,
        prCard1CombinationDetails,
        setprCard1CombinationDetails,
        prCard2CombinationDetails,
        setprCard2CombinationDetails,
        prPopupCombinationDetails,
        setprPopupCombinationDetails
      }}
    >
      {children}
    </SupportContext.Provider>
  );
};

// Custom Hook for easy access
export const useSupport = () => useContext(SupportContext);
